import theme from '@styles/theme';
export default {
  vidoeBlockSection: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    position: 'relative'
  },
  vidoeBlock: (blockCount: number) => {
    const blockWidth = 100 / blockCount;
    return {
      width: ['100%', '100%', '100%', `calc(${blockWidth}% - ${blockCount > 1 ? '1px' : 0})`],
      height: ['100vw', '100vw', '73.3072917vw', '49.9305556vw', '49.9305556vw', '46.875vw'],
      position: 'relative',
      '&:first-of-type': {
        mb: ['2px', '2px', '4px', 0]
      }
    };
  },
  videoBlockContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    zIndex: theme.zIndex.documentUp
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center'
  }
};